import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoaderService} from '@app/core/services/loader/loader.service';
import {CommonService} from '@app/shared/services/common/common.service';
import {GetStoreInterface} from '@app/shared/services/common/getStoreList.interface';
import {OrderFilter, OrderFilterEmitter} from '@app/feature/store-admin/components/reports/order-shopify/IlistOrder';

@Component({
  selector: 'app-order-filter',
  templateUrl: './order-filter.component.html',
  styleUrls: ['./order-filter.component.css']
})
export class OrderFilterComponent implements OnInit {
  @Output() search = new EventEmitter<OrderFilterEmitter>();
  @Output() export = new EventEmitter();
  @Input() orderFilter: OrderFilter = {
    storeId: 0,
    orderStatus: 0,
    orderedUserName: null,
    orderUserEmail: null,
    orderNumber: null,
    isOrderDesk: false,
    style: null,
    startDate: null,
    endDate: null
  };
  storeList: GetStoreInterface[] = [];
  getShopifyStoreForOrder: boolean = true
  constructor(
    private commonService: CommonService,
    private loader: LoaderService) {
  }

  ngOnInit() {
    this.fn_getStoreList();
  }
  downloadExcel(){
    this.export.emit();
  }

  searchEvent(cleanup = false) {
    if(this.orderFilter.storeId == -1){
      this.orderFilter.isOrderDesk = true;
    }else{
      this.orderFilter.isOrderDesk = false;
    }
    this.search.emit({cleanup: cleanup, storeList: this.storeList});
  }

  /** Function to get store list */
  fn_getStoreList() {
    this.loader.show();
    this.commonService.getStoreList('',
      0,
      0,
      false,
      this.commonService.getUser().userId, this.getShopifyStoreForOrder).subscribe((res) => {
      if (res.StatusCode === 200) {
        this.storeList = res.Data.ResponseData;
        this.searchEvent(false);
      } else if (res.StatusCode === 204 || res.StatusCode === 404) {
        this.storeList = [];
      }
      this.loader.hide();
    }, () => {
      this.loader.hide();
    });
  }
    GetShopifyStore(arg0: string, arg1: number, arg2: number, arg3: boolean, userId: string, GetShopifyStore: any) {
        throw new Error("Method not implemented.");
    }

}
